import * as moment from 'moment';
import { MILLISECONDS_IN_DAY } from '../types/constants';

/**
 * Calculates the number of full days between two dates.
 */
export function getDateDifferenceInDays(firstDate: Date, secondDate: Date): number {
  return Math.floor(Math.abs((firstDate.getTime() - secondDate.getTime()) / MILLISECONDS_IN_DAY));
}

/**
 * Generates a range of formatted months/year strings. Examples ['202006', '202007, '202008]
 * @params numberOfMonths - The number of months to generate in the array
 * @returns The array containing all the formatted months
 */
export function createMomentMonthsRange(numberOfMonths: number = 12): string[] {
  const arr: string[] = [];

  for (let i: number = 1; i <= numberOfMonths; i++) {
    const momentMonth: string = moment(new Date())
      .startOf('month')
      .add(i, 'month')
      .locale('en-GB')
      .format('YYYYMM');

    arr.push(momentMonth);
  }

  return arr;
}
